import { logError } from '@/src/utils/logError'
import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define the payload type for S2S events
interface S2SEventPayload {
    id: string
    schemaName: string
    schemaVersion: string
    timestamp: number
    tz: string
    data: any
}

export const analyticsApi = createApi({
    reducerPath: 'analyticsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: headers => {
            return setCommonHeaders(headers)
        }
    }),
    endpoints: builder => ({
        sendS2SEvent: builder.mutation<any, S2SEventPayload>({
            query: payload => ({
                url: '/flight/search/v2/logui',
                method: 'POST',
                body: payload
            }),
            transformErrorResponse: (response, meta, arg) => {
                // Log error using your existing logError utility
                logError('sendS2SEvent', response)
                return response
            }
        })
    })
})

export const { useSendS2SEventMutation } = analyticsApi

export default analyticsApi
